import script from "./guide-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./guide-item.vue?vue&type=script&setup=true&lang=ts"

import "./guide-item.vue?vue&type=style&index=0&id=73389906&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73389906"]])

export default __exports__